export default defineNuxtPlugin(() => {
  const windowWidth = ref(1024)

  const timerId = ref<number>(0)
  // 一定時間操作がされなかった際に発火させるため
  const debounce = (func: any) => {
    return (...args: any) => {
      if (window) {
        if (timerId.value) {
          clearTimeout(timerId.value)
        }
        timerId.value = window.setTimeout(() => {
          func(...args)
        }, 100)
      }
    }
  }
  const getScreenWidth = () => {
    debounce(() => {
      if (window) {
        return (windowWidth.value = window.innerWidth)
      }
      return windowWidth.value
    })()
  }

  if (window) {
    windowWidth.value = window.innerWidth
    window.addEventListener('resize', getScreenWidth)
  }

  const isMobile = computed(() => {
    if (import.meta.server) {
      return false
    } else {
      return windowWidth.value <= 768
    }
  })

  return {
    provide: {
      isMobile,
    },
  }

})
